import { create } from "zustand";

const useStore = create((set) => ({
  cart: [],  
  addToCart: (country) => set((state) => ({
    cart: [...state.cart, country]  
  })),
  removeFromCart: (countryId) => set((state) => ({
    cart: state.cart.filter((c) => c.id !== countryId) 
  })),
  clearCart: () => set({ cart: [] }), 
  updateCart: (updatedCountry) => set((state) => {
    const updatedCart = state.cart.map(item => 
      item.country.id === updatedCountry.country.id
        ? { ...item, selectedOptions: updatedCountry.selectedOptions }
        : item
    );
    return { cart: updatedCart };
  })
}));

export default useStore;